module.exports = __webpack_public_path__ + "img/plus-yellow.2ba9b269.svg";